import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ISessionService } from '@insight/services';

@Injectable({
	providedIn: 'root'
})
export class FrontendGuardService {

	constructor(
		private router: Router,
		private sessionService: ISessionService
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean> {

		if (!this.sessionService.isAuth()) {
			return this.router.navigate(['/auth/login'], {
				queryParams: { returnUrl: state.url }
			})
		}

		return this.checkTokenExpiration()
			.pipe(
				switchMap(() => {
					// if (!this.sessionService.hasMn('fnSiteplanTemporaryLock')) {
					// 	return this.router.navigateByUrl('/unauthorized-access', {
					// 		skipLocationChange: true
					// 	});
					// }
					return of(true);
				})
			);

	}

	canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean> {

		if (!this.sessionService.isAuth()) {
			const fullPath = segments.reduce((path, currentSegment) => {
				return `${path}/${currentSegment.path}`;
			}, '');

			return this.router.navigate(['/auth/login'], {
				queryParams: { returnUrl: fullPath }
			});
		}

		return this.checkTokenExpiration()
			.pipe(
				switchMap(() => {
					// if (!this.sessionService.hasMn('fnSiteplanTemporaryLock')) {
					// 	return this.router.navigateByUrl('/unauthorized-access', {
					// 		skipLocationChange: true
					// 	});
					// }
					return of(true);
				})
			);
	}

	checkTokenExpiration() {
		return new Observable((observer) => {
			if (!this.sessionService.isTokenExpired()) {
				observer.next();
			} else {
				this.sessionService.refreshToken()
					.subscribe(() => {
						observer.next();
					});
			}
		});
	}

}
